import Http from "../http";

class DashboardServ{
    static async getDashboardServices(){
        return Http.get('/dashboard');
    }
    static async Services(id){
        return Http.get(`/dashboard_services/${id}`)
    }
    static async updateServices(id,formData){
        return Http.update(`/dashboard_services/${id}`,formData)
    }

}
export default DashboardServ

